var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispensedAlchemist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76562 15.0909L4.5 11L7.23438 15.0909L7.23319 15.092C7.71302 15.7144 8 16.5042 8 17.3636C8 19.3719 6.433 21 4.5 21C2.567 21 1 19.3719 1 17.3636C1 16.5042 1.28698 15.7144 1.76681 15.092L1.76562 15.0909Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562 15.0909L12.5 11L15.2344 15.0909L15.2332 15.092C15.713 15.7144 16 16.5042 16 17.3636C16 19.3719 14.433 21 12.5 21C10.567 21 9 19.3719 9 17.3636C9 16.5042 9.28698 15.7144 9.76681 15.092L9.76562 15.0909Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7656 15.0909L20.5 11L23.2344 15.0909L23.2332 15.092C23.713 15.7144 24 16.5042 24 17.3636C24 19.3719 22.433 21 20.5 21C18.567 21 17 19.3719 17 17.3636C17 16.5042 17.287 15.7144 17.7668 15.092L17.7656 15.0909Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 22H24V24H1V22Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8H24V10H1V8Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H5.46771L4.8586 5.40996H2.07002L1.49422 7H0L2.7172 0H4.20666L7 7ZM4.40653 4.23056L3.44528 1.63302L2.50306 4.23056H4.40653Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispensedAlchemist);
export default __webpack_public_path__ + "static/media/DispensedAlchemist.cbe226e8e522090047e4e78a285dd142.svg";
export { ForwardRef as ReactComponent };